export default "__VITE_ASSET__BReuWTmG__"